module.exports = __webpack_public_path__ + "img/hasselt-4.f3571050.jpg";